function recalculateOptions($product) {
	let $checked = $product.find('.option').filter(function (i, e) {
		return $(e).find('input[type="checkbox"]:checked').length > 0;
	});

	let priceOptions = 0;
	$checked.each(function (i, e) {
		priceOptions += Number($(e).data('price')) || 0;
	});

	let $priceElement = $product.find('.price-area');
	let priceBase = Number($priceElement.data('base-price')) || 0;
	let priceWithOptions = priceBase + priceOptions;
	let pickupPercent = Number($priceElement.data('pickup-discount-percent')) || 0;
	// В корзине скидка самовывоза применяется и к выбранным опциям.
	let pickupPrice = Math.max(0, priceWithOptions - Math.round(priceWithOptions * pickupPercent / 100));

	$priceElement.find('del').toggleClass('d-none', priceOptions > 0);
	$priceElement.find('[data-product-price]').text(output_money(priceWithOptions));
	$priceElement.find('[data-pickup-price]').text(output_money(pickupPrice));
	$product.find('[data-options-extra]').text((priceOptions > 0 ? '+' : '') + output_money(priceOptions));
	$product.find('[data-options-total]').text(output_money(priceWithOptions));
	$product.find('[data-options-pickup-total]').text(output_money(pickupPrice));

	return {
		options: $checked,
		priceOptions: priceOptions
	}
}

$(function () {
	$('[data-product], [data-product-options-modal]').has('[data-options]').each(function () {
		recalculateOptions($(this));
	});
});

$(document).on('shown.bs.modal', '#modal-product-options', function () {
	recalculateOptions($(this));
});

$(document).on('change', '[data-product] .vg-shop-options input[type="checkbox"]', function () {
	let $product = $(this).closest('[data-product]');
	recalculateOptions($product);
});

$(document).on('change', '#modal-product-options input[type="checkbox"]', function () {
	let $product = $(this).closest('#modal-product-options');
	let recalculate = recalculateOptions($product);

	$product.find('[data-cart][data-action="add"]')
		.text(recalculate.options.length > 0 ? "Добавить" : "Добавить без опций");
});
